import React from 'react';
import messages from '../../../locale/messages';
import TaxContainer from './TaxContainer';
import DashboardLayout from '../../../components/Shop/StoreLayout/Layout/DashboardLayout';

function action({ store, params, intl }) {
    const title = intl.formatMessage(messages.tax);

    let isStoreAuthenticated = store.getState().runtime.isStoreAuthenticated;

    if (!isStoreAuthenticated) {
        return { redirect: '/store/login' };
    };

    return {
        title,
        component: (
            <DashboardLayout>
                <TaxContainer title={title} />
            </DashboardLayout>
        )
    }
}

export default action;
